export type PublishBundleErrorClass = 'platform' | 'user';

export type PublishBundleStep =
  | 'install-dependencies'
  | 'type-check'
  | 'bundle'
  | 'files-extraction';

const CLI_STARTED_MARKER = 'CLI Version:';

/**
 * Distinguishes a publish-bundle failure the user caused (CLI started, or tsc
 * with diagnostics) from one the platform caused (CLI never started / no
 * diagnostics).
 *
 * Empty logs share the same `Bundling error logs [step: …]:` prefix as a
 * TypeScript failure in Datadog, so they classify as platform even on
 * `type-check`. The CLI prints `CLI Version:` as soon as it boots, so its
 * absence on non-empty logs is also the platform signal.
 *
 * `files-extraction` only runs after a successful CLI bundle, so the logs
 * almost always include `CLI Version:` even though missing files are a
 * platform outcome.
 */
export function classifyPublishBundleFailure({
  step,
  logs,
}: {
  step: PublishBundleStep;
  logs: string;
}): PublishBundleErrorClass {
  if (step === 'files-extraction' || logs.trim().length === 0) {
    return 'platform';
  }
  if (step === 'type-check' || logs.includes(CLI_STARTED_MARKER)) {
    return 'user';
  }
  return 'platform';
}
